export const generateAlphabetLabel = (index) => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  
  if (index < 26) {
    return alphabet[index];
  } else {
    const firstLetter = Math.floor(index / 26) - 1;
    const secondLetter = index % 26;
    return alphabet[firstLetter] + alphabet[secondLetter];
  }
};

export const renameAllTabs = (tabsArray) => {
  return tabsArray.map((tab, index) => ({
    ...tab,
    label: generateAlphabetLabel(index)
  }));
};

export const getWorkoutName = (programName, tabLabel, workoutIndex) => {
  const baseName = programName || 'Workout';
  return `${baseName} ${tabLabel}${workoutIndex + 1}`;
};